import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SchedulerDemo.html?raw';


import "../SharedTypes/mixed";

class SchedulerDemo extends compose(_WidgetBaseSP) {
	templateString: any = template;

    schedulerNode: HTMLDivElement;

    initScheduler(): void {

        var isReadOnly = function (endDate) {
            return (endDate < new Date(2021, 6, 31, 0, 0));
        };
        window.getRoomName = function (value) {
            return value.resourceData[value.resource.textField];
        };
        window.getRoomType = function (value) {
            return value.resourceData.type;
        };
        window.getRoomCapacity = function (value) {
            return value.resourceData.capacity;
        };
        
        var data = new window.ej.base.extend([], window.roomData, null, true);
        var scheduleObj = new window.ej.schedule.Schedule({
            cssClass: 'room-schedule',
            width: '100%',
            height: '650px',
            selectedDate: new Date(2021, 7, 2),
            currentView: 'TimelineDay',
            workHours: {
                start: '08:00',
                end: '18:00'
            },
            timeScale: {
                slotCount: 1,
                interval: 60
            },
            views: [
                { option: 'TimelineDay' },
                { option: 'TimelineWeek' },
                { option: 'Week' },
                { option: 'Month' },
            ],
            resourceHeaderTemplate: '#resource-template',
            group: {
                enableCompactView: false,
                resources: ['MeetingRoom', 'MeetingRoomMinimal']
            },
            resources: [{
                field: 'RoomId', title: 'Room Type',
                name: 'MeetingRoom', allowMultiple: true,
                dataSource: [
                    { text: 'Großer Saal', id: 1, color: '#ea7a57', capacity: 20, type: 'Conference' },
                    { text: 'Kleiner Saal', id: 2, color: '#7fa900', capacity: 7, type: 'Cabin' },
                    { text: 'Roter Saal', id: 3, color: '#5978ee', capacity: 5, type: 'Cabin' },
                    { text: 'Blauer Saal', id: 4, color: '#fec200', capacity: 15, type: 'Conference' },
                    { text: 'Gigantischer Saal', id: 5, color: '#df5286', capacity: 25, type: 'Conference' },
                    { text: 'Neuer Saal', id: 6, color: '#00bdae', capacity: 10, type: 'Cabin' },
                    { text: 'Halle 1', id: 7, color: '#865fcf', capacity: 20, type: 'Conference' },
                    { text: 'Halle 2', id: 8, color: '#1aaa55', capacity: 8, type: 'Cabin' },
                    { text: 'Halle 3', id: 9, color: '#df5286', capacity: 30, type: 'Conference' },
                    { text: 'Foyer', id: 10, color: '#710193', capacity: 25, type: 'Conference' }
                ],
                textField: 'text', idField: 'id', colorField: 'color'
            }, {
                field: 'RoomId', title: 'Important Room Type',
                name: 'MeetingRoomMinimal', allowMultiple: true,
                dataSource: [
                    { text: 'Nestle', id: 33, color: '#5978ee', capacity: 5, type: 'Cabin' },
                    { text: 'Phoenix', id: 44, color: '#fec200', capacity: 15, type: 'Conference' },
                    { text: 'Mission', id: 55, color: '#df5286', capacity: 25, type: 'Conference' },
                ],
                textField: 'text', idField: 'id', colorField: 'color'
            }],
            eventSettings: {
                dataSource: data,
                fields: {
                    id: 'Id',
                    subject: { title: 'Summary', name: 'Subject' },
                    location: { title: 'Location', name: 'Location' },
                    description: { title: 'Comments', name: 'Description' },
                    startTime: { title: 'From', name: 'StartTime' },
                    endTime: { title: 'To', name: 'EndTime' }
                }
            },
            popupOpen: function (args) {
                var data = args.data;
                if (args.type === 'QuickInfo' || args.type === 'Editor' || args.type === 'RecurrenceAlert' || args.type === 'DeleteAlert') {
                    var target = (args.type === 'RecurrenceAlert' ||
                        args.type === 'DeleteAlert') ? args.element[0] : args.target;
                    if (!window.ej.base.isNullOrUndefined(target) && target.classList.contains('e-work-cells')) {
                        if ((target.classList.contains('e-read-only-cells')) || (!scheduleObj.isSlotAvailable(data))) {
                            args.cancel = true;
                        }
                    }
                    else if (!window.ej.base.isNullOrUndefined(target) && target.classList.contains('e-appointment') &&
                        (isReadOnly(data.EndTime))) {
                        args.cancel = true;
                    }
                }
            },
            renderCell: function (args) {
                if (args.element.classList.contains('e-work-cells')) {
                    if (args.date < new Date(2021, 6, 31, 0, 0)) {
                        args.element.setAttribute('aria-readonly', 'true');
                        args.element.classList.add('e-read-only-cells');
                    }
                }
                if (args.elementType === 'emptyCells' && args.element.classList.contains('e-resource-left-td')) {
                    var target = args.element.querySelector('.e-resource-text');
                    target.innerHTML = '<div class="name">Rooms</div><div class="type">Type</div><div class="capacity">Capacity</div>';
                }
            },
            eventRendered: function (args) {
                var data = args.data;
                if (isReadOnly(data.EndTime)) {
                    args.element.setAttribute('aria-readonly', 'true');
                    args.element.classList.add('e-read-only');
                }
            },
            actionBegin: function (args) {
                if (args.requestType === 'eventCreate' || args.requestType === 'eventChange') {
                    var data = void 0;
                    if (args.requestType === 'eventCreate') {
                        data = args.data[0];
                    }
                    else if (args.requestType === 'eventChange') {
                        data = args.data;
                    }
                    if (!scheduleObj.isSlotAvailable(data)) {
                        args.cancel = true;
                    }
                }
            }
        });

        scheduleObj.appendTo(this.schedulerNode);

        (window as any).scheduleObj = scheduleObj;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.initScheduler();
	}

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.inherited(arguments);

    }
}

export default mdsWidget(SchedulerDemo);